// Copied from labcoat/entities -- delete when migrating

import { z } from 'zod';

const SearchTermTypeValues = [
  'specialty',
  'condition',
  'procedure',
  'synonym',
] as const;
export const SearchTermTypeEnum = z.enum(SearchTermTypeValues);

export const SearchTermTypeaheadSchema = z.object({
  id: z.string(),
  name: z.string(),
  type: SearchTermTypeEnum,
  specialties: z.array(z.string()).optional(),
});

export type SearchTermTypeaheadEntity = z.infer<
  typeof SearchTermTypeaheadSchema
>;
export type SearchTermType = z.infer<typeof SearchTermTypeEnum>;
